(function ($) {
  'use strict';

  var backLink = $('.js-back-to-course'),
    courseUrl = getURLParam('backToCourse');

  if (courseUrl) {
    backLink.attr('href', courseUrl);
    backLink.removeClass('hidden');
  }

  /**
   * Takes a string value of the expected parameter.
   * Returns a decoded string of the value of the parameter.
   * Returns false if no paramter found
   * @param {String} param 
   * @returns {Object}
   */
  function getURLParam(param) {
    var parameters = window.location.search.substring(1);
    parameters = parameters.split('&');

    for (var i = 0; i < parameters.length; i++) {
      var data = parameters[i].split('='),
        name = data[0],
        val = decodeURIComponent(data[1]);

      if (name === param) {
        return val;
      }
    }

    return false;
  }
}(jQuery));